/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import { removeFiltersByKey } from 'store/Filters/actions';
import { useDispatch, useSelector } from 'react-redux';
import { selectTags } from 'store/Tags/selectors';
import { newGetVulns } from 'store/Manage/filterActions';
import { getData } from 'store/Host/actions';
import { eq, createFilter } from 'store/Filters/constants';
import { SEARCH_BY_ENTITIES, ENTITIES } from 'store/Filters/entitiesConstants';
import get from 'lodash/get';
import { isFilteringBy } from 'store/Filters/selectors';
import { useLocation } from 'react-router-dom';
import { getVulnsByAsset } from 'store/Contextualization/AssetDetail/actions';
import { selectCurrentWorkspace } from 'store/Faraday/selectors';
import { selectCurrentHost } from 'store/Host/selectors';
import defaultFilters from './defaultFilters';
import {
  Subtitle, Title, Flex, Clear, ExpandedIcon, CollapsedIcon, Content, TextEmptyTags
} from '../styled';
import { SeverityFilter, CheckBoxFilter, TagFilter } from './filterTypes';
import { getHostsData } from 'store/HostsGeneral/actions';
import { getVulnsGeneral } from 'store/ManageGeneral/actions';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { FEATURE_TAGS, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';

const QuickFilters = () => {
  const [isExpanded, setIsExpanded] = useState(true);
  const location = useLocation();
  const currentWorkspace = useSelector(selectCurrentWorkspace);
  const currentAsset = useSelector(selectCurrentHost);
  const assetId = get(currentAsset, '_id', 0);
  const currentLocationEntity = () => {
    if (location.pathname.includes(`host/${currentWorkspace}/${assetId}/vulns`)) return ENTITIES.vulnsAssets;
    else if (location.pathname.includes('/hosts')) return ENTITIES.assetsGeneral;
    else if (location.pathname.includes('/vulnerabilities')) return ENTITIES.vulnsGeneral;
    else return SEARCH_BY_ENTITIES.find((e) => location.pathname.includes(e.pathname));
  };
  const entityName = get(currentLocationEntity(), 'name.value', 'vulns');
  const toggleExpanded = () => setIsExpanded(!isExpanded);
  const hasTagsFeature = useSelector((state) => selectAllowedByRole(state, FEATURE_TAGS, PERMISSION_TYPES.READ));
  const tags = useSelector(selectTags);
  const tagObj = {
    title: 'Tags',
    options: tags.map((tag) => tag.name),
    name: 'tags__name',
    type: 'tags',
    displayOptions: tags,
    filter: (filter) => (createFilter('tags__name', eq.name.value, filter)),
    showClear: true
  };

  const noTagsText = 'No Tags Found';

  return (
    <>
      <Subtitle>Quick Filters</Subtitle>
      {defaultFilters[entityName].map((filter) => <QuickFilterItem { ...filter } key={ JSON.stringify(filter) } entityName={ entityName } showClear={ filter.showClear } />)}
      {(entityName === 'vulns' && hasTagsFeature)
        ? tags.length > 0
          ? <QuickFilterItem { ...tagObj } entityName={ entityName } showClear={ tagObj.showClear } />
          : (
            <>
              <Flex>
                <Title>{tagObj.title}</Title>
                <Clear>Clear</Clear>
                { isExpanded ? <ExpandedIcon onClick={ toggleExpanded } /> : <CollapsedIcon onClick={ toggleExpanded } /> }
              </Flex>
              <Content isExpanded={ isExpanded }><TextEmptyTags>{noTagsText}</TextEmptyTags></Content>
            </>
            )
        : null}

    </>
  );
};

const QuickFilterItem = ({
  title, options, type, filter, name, displayOptions, entityName, showClear
}) => {
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const [isExpanded, setIsExpanded] = useState(true);

  const anyFilterApplied = options.some((option) => (isFilteringBy(state, entityName, filter(option))));

  const toggleExpanded = () => setIsExpanded(!isExpanded);

  const handleClick = () => {
    if (showClear && anyFilterApplied) {
      dispatch(removeFiltersByKey(entityName, name));
      if (entityName === 'vulns') dispatch(newGetVulns());
      if (entityName === 'assets') dispatch(getData());
      if (entityName === 'vulnsAssets') dispatch(getVulnsByAsset());
      if (entityName === 'assetsGeneral') dispatch(getHostsData());
      if (entityName === 'vulnsGeneral') dispatch(getVulnsGeneral());
    }
  };

  return (
    <>
      <Flex>
        <Title>{title}</Title>
        { showClear && <Clear onClick={ handleClick }>Clear</Clear> }
        { isExpanded ? <ExpandedIcon onClick={ toggleExpanded } /> : <CollapsedIcon onClick={ toggleExpanded } /> }
      </Flex>

      <Content vertical={ type === 'checkbox' } isExpanded={ isExpanded }>
        {type === 'severity' && (displayOptions.map((option, i) => <SeverityFilter key={ `severity_${option}` } entityName={ entityName } option={ option } filter={ filter(options[i]) } />))}
        {type === 'checkbox' && displayOptions.map((option, i) => <CheckBoxFilter key={ `checkboux_${option}` } entityName={ entityName } option={ option } filter={ filter(options[i]) } />)}
        {type === 'tags' && displayOptions.map((option, i) => <TagFilter key={ `tags_${options[i]}` } entityName={ entityName } name={ options[i] } filter={ filter(options[i]) } />)}
      </Content>
    </>
  );
};

export default QuickFilters;
